import React from "react";
export const generateToasterMessageWithLink = (message, linkText, href, target) => (React.createElement("span", null,
    message,
    " ",
    React.createElement("a", { href: href, target: target ?? "_self" }, linkText)));
